import { cn } from "@/lib/utils";

export type MarketingButtonVariant = "primary" | "secondary" | "teal" | "blue";

const VARIANTS: Record<MarketingButtonVariant, string> = {
  primary:
    "bg-marketing-blue text-white shadow-[0_0_24px_rgba(66,87,255,0.58)]",
  secondary: "border border-white/40 bg-white/[0.06] text-white",
  teal: "bg-teal-500 text-marketing-navy shadow-[0_0_24px_rgba(66,87,255,0.58)]",
  blue: "bg-blue-600 text-white shadow-[0_0_24px_rgba(66,87,255,0.58)]",
};

export function marketingButtonClass(
  variant: MarketingButtonVariant = "primary",
  className?: string,
) {
  return cn(
    "inline-flex min-h-[52px] items-center justify-center gap-[10px] rounded-full px-[23px] font-open-sans text-[16px] font-extrabold transition-[transform,box-shadow,background] duration-200 motion-safe:hover:-translate-y-0.5",
    VARIANTS[variant],
    className,
  );
}
